<template>
    <div id="searchResults" class="search-results-container" :class="{'quick-search': searchType === 'Smart'}">
        <div class="feature-area-wrapper">
            <div class="feature-area feature-area-compact">

                <searchResultsMenu />
                <div class="sort-note" v-if="!projectListTable.sortField && searchMeta && searchMeta.sorted_by_relevance">Results are sorted by <span>Relevance</span></div>
                <navigationTabs />
            </div>
        </div>

        <div class="searchResults">
            <div class="adv-results-container" ref="resultsContainer">
                <facets class=""  ref="facets"/>
                <div class="content-with-sidebar">
                    <div class="field-error-message error-large" v-if="serviceError">
                        Unable to load data
                        <div class="error-code">
                        {{serviceError}}
                        </div>
                    </div>
                    <div class="tableContainer" v-if="$route.name === 'list'">
                        <dataTable class="dataTable" :table="projectListTable" fromPage="searchResults"  ref="dataTable" />
                    </div>
                    <Charts v-if="$route.name === 'charts'" ref="Charts" :drillDownTable="drillDownTable" :circlesTable="drillDownTable"/>
                    <googleMap v-if="$route.name === 'map'" ref="googleMap" id="googleMap" :drillDownTable="drillDownTable"  :mapTable="projectListTable"/>
                </div>
            </div>
        </div>
        <!-- Export -->
        <exportModule v-if="$route.name === 'list'" ref="exportModule"  fromPage="searchResults"/>

    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import dataTable from '@/components/global/dataTable.vue';
import navigationTabs from '@/components/global/navigationTabs.vue';
import Charts from '@/components/global/Charts.vue';
import googleMap from '@/components/global/map.vue';
import facets from '@/components/global/facets.vue';
import searchResultsMenu from '@/components/global/searchResultsMenu.vue';
import globalMixins from '@/globalMixins';
import projectListMixins from '@/projectListMixins';
import exportModule from  '@/components/global/export.vue';
import bus from '@/shared/event-bus.js';

export default {
    name: 'searchResults',
    mixins: [globalMixins, projectListMixins],
    components: {
      dataTable,
      navigationTabs,
      facets,
      Charts,
      googleMap,
      exportModule,
      searchResultsMenu
    },
    computed: {
        ...mapGetters([
            'searchType',
            'searchCriteria',
            'editSearchCriteria',
            'graphData',
            'exportCriteria',
            'piSummaryProjects',
            'selectedPerson'
        ]),
    },
    data: function () {
        return {
            serverless: false,
            drillDownTable: null,
            isPopOut: false,
            serviceError: null,
            pageName: 'list',
            projectListMapTable: null
        };
    },
    mounted () {
        // if (window.readCookie('searchMode')) {
        //     this.setSearchMode('advanced-search');
        // } else {
        //     this.setSearchMode('');
        // }
        if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
            // redirect to home page if no Search ID
            this.$router.push({ path: '/' });
        } else {
            this.projectListMapTable = copyData(this.projectListTable);
            this.projectListMapTable.name = "mapTable";
            this.initPage();
        }
    },
    methods: {
        ...mapActions([
            'setFullscreen',
            'setEditSearchResultsFlag',
            'setLookup',
            'setSearchMode',
            'setPersonSummaryProjects'
        ]),
        initPage () {
            this.showCriteria = false;
            this.drillDownTable = copyData(this.projectListTable);
            window.scrollTo(0, 0);
            if (!this.searchResults) {
                this.isLoading = true;
                if (this.$route.query.sort_field) {
                    this.projectListTable.sortField = this.$route.query.sort_field;
                }
                if (this.$route.query.sort_order) {
                    this.projectListTable.sortOrder = this.$route.query.sort_order;
                }
                if (this.$route.name === 'list') {
                    if (this.$route.query) {
                        this.parseFacetFiltersFromURL();
                    }

                    this.getProjectSearchResults(false);
                }
            } else {
                if (this.$store.state.searchMeta && this.$route.name === 'list') {
                    if (this.$store.state.searchMeta.sort_field) {
                        this.projectListTable.sortField = this.$store.state.searchMeta.sort_field;
                        this.projectListTable.sortOrder = this.$store.state.searchMeta.sort_order;
                    }
                    else if (!this.$store.state.searchMeta.sorted_by_relevance && this.projectListTable.sortField === '') {
                        this.projectListTable.sortField = 'name';
                        this.projectListTable.sortOrder = 'asc';
                    }
                }
            }
            this.setFullscreen(true);

            let $this = this;
            setTimeout(() => {
                if ($this.$route.name === 'list')  {
                    bus.$emit('update:resize');
                }
            }, 101);
        },
        setSortDetails ($event, selectedSortColumn) {
            this.isLoading = true;
            this.setProjectSortDetails(selectedSortColumn);
        },
        exportData (selectedFieldsToExport, callback) {
            var searchParam = {
                "search_id": this.$route.params.search_id,
                "facet_filters": this.$refs.facets.searchFacetCriteria,
                "export_fields": selectedFieldsToExport,
                "file_format": this.$refs.exportModule.exportFileFormat,
                "sort_field": this.projectListTable.sortField,
                "sort_order": this.projectListTable.sortOrder,
                "criteria": this.$refs.exportModule.exportSearchCriteria ?  this.exportCriteria : null
            }
            this.getExportFile(searchParam, callback);
        },
        scrollToResultsTop () {
            let resultsOffsetTop = this.getResultsContainerOffsetTop();

            // only scroll up if user view is scrolled below top of table
            if (window.pageYOffset > resultsOffsetTop) {
                window.scrollTo(0, this.getResultsContainerOffsetTop());
            }
        },
        getResultsContainerOffsetTop () {
            return this.$refs.resultsContainer ? this.$refs.resultsContainer.offsetTop : 0;
        },
        goBack () {
            var self = this;

            this.setPersonSummaryProjects(null);
            if (self.$refs.drillDownTable) {
                self.$refs.drillDownTable.table.loadingMoreData = false;
            }
            self.loadSlide = false;
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

</style>